import { WaitlistButton } from "@/components/landing/WaitlistButton";

const HERO_PRODUCE = "/hero-produce.jpg";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#F9F6F0] pt-20 pb-20 md:pt-28 md:pb-28"
    >
      <div
        aria-hidden
        className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#4A6B41]/10 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute bottom-0 -left-32 h-80 w-80 rounded-full bg-[#C86D51]/10 blur-3xl"
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12 grid lg:grid-cols-2 gap-14 lg:gap-10 items-center">
        <div className="s2t-fade-up">
          <h1 className="font-sans font-extrabold text-4xl sm:text-5xl lg:text-6xl text-[#1C241B] tracking-tight leading-[1.12]">
            Your Local Food Connection.
          </h1>

          <p className="mt-6 max-w-xl font-sans text-base sm:text-lg text-[#5A6757] leading-relaxed">
            Source2Table connects you directly with local farmers, growers, and
            producers, making it easier to discover fresh vegetables, fruits,
            meat, dairy, eggs, honey, flowers, and more. Explore nearby farms and
            markets, check product availability, discover how your food is
            produced, and connect directly with the people behind it. Support
            local businesses, shop with confidence, and strengthen your
            community — all in one convenient app.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <WaitlistButton testid="hero-join-waitlist-btn" variant="solid" />
          </div>
        </div>

        <div className="relative s2t-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl ring-1 ring-[#4A6B41]/10 aspect-[4/5]">
            <img
              src={HERO_PRODUCE}
              alt="Fresh organic local produce at a farm market"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
